import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthModal } from "@/components/AuthModal";
import AuthCallback from "@/pages/AuthCallback";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Profile from "@/pages/Profile";
import PostCampaign from "@/pages/PostCampaign";
import Discover from "@/pages/Discover";
import CampaignDetail from "@/pages/CampaignDetail";
import FindInfluencers from "@/pages/FindInfluencers";
import WalletPage from "@/pages/Wallet";
import GoogleYouTubeCallback from "@/pages/GoogleYouTubeCallback";
import AdminPanel from "@/pages/AdminPanel";
import SeoLanding from "@/pages/SeoLanding";
import CreatorPublic from "@/pages/CreatorPublic";
import Directory from "@/pages/Directory";
import RegionHub from "@/pages/RegionHub";
import NotFound from "@/pages/NotFound";
import { ActivityTracker } from "@/components/ActivityTracker";

function AppRouter() {
  const location = useLocation();
  // Emergent Google OAuth returns to {redirect}#session_id=... — handle it before any route/guard runs.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
    <ActivityTracker />
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/onboarding" element={<ProtectedRoute requireProfile={false}><Onboarding /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/campaigns/new" element={<ProtectedRoute><PostCampaign /></ProtectedRoute>} />
      <Route path="/campaigns/:id" element={<ProtectedRoute><CampaignDetail /></ProtectedRoute>} />
      <Route path="/discover" element={<ProtectedRoute><Discover /></ProtectedRoute>} />
      <Route path="/influencers" element={<ProtectedRoute><FindInfluencers /></ProtectedRoute>} />
      <Route path="/wallet" element={<ProtectedRoute><WalletPage /></ProtectedRoute>} />
      <Route path="/auth/google" element={<ProtectedRoute><GoogleYouTubeCallback /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute requireProfile={false}><AdminPanel /></ProtectedRoute>} />
      <Route path="/creators/:slug" element={<CreatorPublic />} />
      <Route path="/influencer-directory" element={<Directory />} />
      <Route path="/regions/:slug" element={<RegionHub />} />
      <Route path="/influencers/*" element={<SeoLanding />} />
      <Route path="/:base/*" element={<SeoLanding />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <AuthModal />
          <Toaster position="top-right" theme="light" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
